var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "computer",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M29.5,2H4.5A2.5,2.5,0,0,0,2,4.5v19A2.5,2.5,0,0,0,4.5,26h8.434l-.375,3H11.5a1.5,1.5,0,1,0,0,3h11a1.5,1.5,0,0,0,0-3H21.441l-.375-3H29.5A2.5,2.5,0,0,0,32,23.5V4.5A2.5,2.5,0,0,0,29.5,2ZM4.5,3h25A1.5,1.5,0,0,1,31,4.5V21H24.5v-.21a3.51,3.51,0,0,0-1.95-3.131L23.207,17H25V16H23a.5.5,0,0,0-.353.146L21.5,17.3,19,16.618v-.593A4.5,4.5,0,0,0,21.5,12V9a4.5,4.5,0,1,0-9,0v3A4.5,4.5,0,0,0,15,16.025v.593l-2.5.679-1.15-1.15A.5.5,0,0,0,11,16H9v1h1.793l.657.659A3.509,3.509,0,0,0,9.5,20.79V21H3V4.5A1.5,1.5,0,0,1,4.5,3Zm8.646,16.354.707-.707-.535-.535,1.791-.487a1.987,1.987,0,0,0,3.781,0l1.791.487-.535.535.707.707.93-.93A2.507,2.507,0,0,1,23.5,20.79V21h-13v-.21a2.506,2.506,0,0,1,1.717-2.366ZM13.5,9.5h3a.5.5,0,0,0,.3-.1l1.577-1.183.707,1.06A.5.5,0,0,0,19.5,9.5h1V12H18.707l-.853-.854A.5.5,0,0,0,17.5,11h-1a.5.5,0,0,0-.353.146L15.293,12H13.5Zm.04-1a3.5,3.5,0,0,1,6.92,0h-.692l-.85-1.278A.5.5,0,0,0,18.2,7.1L16.333,8.5ZM15.5,13a.5.5,0,0,0,.353-.146L16.707,12h.586l.854.854A.5.5,0,0,0,18.5,13h1.85a3.5,3.5,0,0,1-6.7,0Zm.5,3.384a4.368,4.368,0,0,0,2,0V17a1,1,0,0,1-2,0ZM23,30.5a.5.5,0,0,1-.5.5h-11a.5.5,0,1,1,0-1h11A.5.5,0,0,1,23,30.5ZM20.433,29H13.566l.375-3h6.117ZM29.5,25H4.5A1.5,1.5,0,0,1,3,23.5V22H31v1.5A1.5,1.5,0,0,1,29.5,25Z",
    fill: "#174a84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M54,44h1v1H54Z",
    transform: "translate(-26 -21)",
    fill: "#174a84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M27,18h1v1H27Z",
    transform: "translate(-12.5 -8)",
    fill: "#174a84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M35,18h1v1H35Z",
    transform: "translate(-16.5 -8)",
    fill: "#174a84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M50,7h3V8H50Z",
    transform: "translate(-24 -2.5)",
    fill: "#174a84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M50,11h3v1H50Z",
    transform: "translate(-24 -4.5)",
    fill: "#174a84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M50,30h1v1H50Z",
    transform: "translate(-24 -14)",
    fill: "#174a84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M54,30h1v1H54Z",
    transform: "translate(-26 -14)",
    fill: "#174a84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M50,34h3v1H50Z",
    transform: "translate(-24 -16)",
    fill: "#174a84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M43.354,8h1.293V7h-1.5a.5.5,0,0,0-.353.146l-1.5,1.5L42,9.354Z",
    transform: "translate(-19.646 -2.5)",
    fill: "#174a84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M8,7h3V8H8Z",
    transform: "translate(-3 -2.5)",
    fill: "#174a84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M8,11h3v1H8Z",
    transform: "translate(-3 -4.5)",
    fill: "#174a84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M12,30h1v1H12Z",
    transform: "translate(-5 -14)",
    fill: "#174a84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M8,30H9v1H8Z",
    transform: "translate(-3 -14)",
    fill: "#174a84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M8,34h3v1H8Z",
    transform: "translate(-3 -16)",
    fill: "#174a84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M18.646,9.353l.707-.707-1.5-1.5A.5.5,0,0,0,17.5,7H16V8h1.293Z",
    transform: "translate(-7 -2.5)",
    fill: "#174a84"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.3910a20b6c1ebdc343140cfe13a9bdb2.svg";
export { ForwardRef as ReactComponent };